import PropTypes from "prop-types";
import cn from "classnames";
import { Media } from "solar/components/Media";
import { moneyWithoutDecimals, fromPricingSuffix } from "helpers/formatting";
import Container from "solar/components/Container";
import LinkSmooth from "components/shared/stays/LinkSmooth";
import styles from "components/stay/StabSubNav.module.scss";

export default function StabSubNav({
  lowestProduct,
  presentInView,
  actionsInView,
  children,
}) {
  return (
    <div
      className={cn(
        styles.component,
        presentInView ? styles.hidden : styles.visible
      )}
    >
      <Container>
        <div className={styles.wrapper}>
          <div className={styles.grid}>
            {lowestProduct && (
              <Media lessThan="lg">
                <span className={styles.price}>
                  {`From ${moneyWithoutDecimals(lowestProduct.price)}`}
                </span>
                <span className={styles.type}>
                  {` / ${fromPricingSuffix(lowestProduct.pricing_type)}`}
                </span>
              </Media>
            )}
            <Media greaterThan="md">
              <div className={styles.anchors}>
                <div className={styles.anchor}>
                  <LinkSmooth to="overview">Overview</LinkSmooth>
                </div>
                <div className={styles.anchor}>
                  <LinkSmooth to="description">The gist</LinkSmooth>
                </div>
                <div className={styles.anchor}>
                  <LinkSmooth to="surf">The surf</LinkSmooth>
                </div>
                <div className={styles.anchor}>
                  <LinkSmooth to="availability">Availability</LinkSmooth>
                </div>
              </div>
            </Media>
            <div
              className={cn(
                styles.actions,
                presentInView || actionsInView ? styles.hidden : styles.visible
              )}
            >
              {children}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
}

StabSubNav.propTypes = {
  lowestProduct: PropTypes.shape({
    min_guests: PropTypes.number,
    max_guests: PropTypes.number,
    price: PropTypes.string,
    pricing_type: PropTypes.string,
  }).isRequired,
  presentInView: PropTypes.bool.isRequired,
  actionsInView: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};
